/**
 * Autopromo Grid Price Updater
 * Extends component-product-card.js to update autopromo prices when variants change
 */

// TEST: This should ALWAYS show in console if file loads
console.log('🔵 AUTOPROMO UPDATER: Script file is loading...');

(function() {
  'use strict';
  
  console.log('🔵 AUTOPROMO UPDATER: Inside IIFE...');

  // Wait for product-card component to be defined
  function initAutopromoUpdater() {
    // Check if ProductCard class exists
    if (typeof customElements === 'undefined' || !customElements.get('product-card')) {
      // Product card not loaded yet, try again
      setTimeout(initAutopromoUpdater, 100);
      return;
    }

    // Get the ProductCard class
    const ProductCardElement = customElements.get('product-card');
    if (!ProductCardElement) return;

    // Get the prototype
    const prototype = ProductCardElement.prototype;
    if (!prototype) return;

    // Store original updateCardPrice method
    const originalUpdateCardPrice = prototype.updateCardPrice;
    
    if (!originalUpdateCardPrice) {
      // Method doesn't exist, can't patch
      return;
    }

    // Override updateCardPrice to also update autopromo prices
    prototype.updateCardPrice = function(element) {
      // Call original method first
      if (originalUpdateCardPrice) {
        originalUpdateCardPrice.call(this, element);
      }

      // Now update autopromo prices if they exist
      if (!element) return;

      // Get product ID from the swatch element (this is the actual product ID)
      const productId = element.getAttribute('data-product-id') || 
                       element.closest('.card-color-swatch--inner')?.getAttribute('data-product-id');
      
      if (!productId) {
        console.log('[Autopromo] No product ID found on swatch element');
        return;
      }

      console.log('[Autopromo] Found product ID:', productId);

      // Get variant data from the swatch element
      const variantData = element.getAttribute('data-variant');
      if (!variantData) return;

      let variant;
      try {
        variant = JSON.parse(variantData);
      } catch (e) {
        console.error('Autopromo: Error parsing variant data', e);
        return;
      }

      if (!variant || typeof variant.price === 'undefined') return;

      // Find autopromo price container - search within this product-card first, then globally
      let autopromoContainer = this.querySelector(
        `[data-autopromo-price-container][data-product-id="${productId}"]`
      );
      
      if (!autopromoContainer) {
        autopromoContainer = document.querySelector(
          `[data-autopromo-price-container][data-product-id="${productId}"]`
        );
      }

      if (!autopromoContainer) {
        console.log('[Autopromo] No autopromo container found for product ID:', productId);
        return;
      }

      console.log('[Autopromo] Found autopromo container');

      const discountRate = parseFloat(autopromoContainer.getAttribute('data-discount-rate') || '0');
      if (!discountRate || discountRate <= 0) return;

      const originalEl = autopromoContainer.querySelector('[data-autopromo-original-price]');
      const finalEl = autopromoContainer.querySelector('[data-autopromo-final-price]');

      if (!originalEl || !finalEl) return;

      // Get money format
      let moneyFormat = null;
      try {
        const wethemeGlobal = document.getElementById('wetheme-global');
        if (wethemeGlobal) {
          const themeData = JSON.parse(wethemeGlobal.textContent);
          moneyFormat = themeData.moneyFormat;
        }
      } catch (e) {
        // Fallback
      }

      // Format money
      function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
          try {
            return Shopify.formatMoney(cents, moneyFormat);
          } catch (e) {
            // Fallback
          }
        }
        const value = cents / 100;
        return '$' + value.toFixed(2);
      }

      // Calculate prices
      const originalCents = parseInt(variant.price, 10);
      const finalCents = Math.round(originalCents * (1 - discountRate));

      // Format prices
      const originalFormatted = formatMoney(originalCents);
      const finalFormatted = formatMoney(finalCents);

      // Update original price (preserve visually-hidden span)
      const hiddenSpan = originalEl.querySelector('.visually-hidden');
      if (hiddenSpan) {
        const hiddenText = hiddenSpan.textContent || hiddenSpan.innerText;
        originalEl.innerHTML = '<span class="visually-hidden">' + hiddenText + '</span> ' + originalFormatted;
      } else {
        originalEl.textContent = originalFormatted;
      }

      // Update final price
      finalEl.textContent = finalFormatted;
      
      console.log('[Autopromo] Prices updated:', {
        original: originalFormatted,
        final: finalFormatted
      });
    };

    console.log('[Autopromo Grid] ✅ Successfully patched updateCardPrice method');
  }

  // Start initialization - wait for everything to load
  function startInit() {
    console.log('🔵 AUTOPROMO UPDATER: Starting initialization...');
    
    // Try multiple times in case component loads slowly
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max wait
    
    const tryInit = setInterval(function() {
      attempts++;
      const productCard = customElements.get('product-card');
      
      if (attempts === 1) {
        console.log('🔵 AUTOPROMO UPDATER: Checking for product-card...', {
          customElementsExists: typeof customElements !== 'undefined',
          productCardFound: !!productCard,
          attempt: attempts
        });
      }
      
      if (productCard) {
        clearInterval(tryInit);
        console.log('🔵 AUTOPROMO UPDATER: product-card found! Attempting to patch...');
        initAutopromoUpdater();
      } else if (attempts >= maxAttempts) {
        clearInterval(tryInit);
        console.error('🔴 AUTOPROMO UPDATER: product-card component not found after', maxAttempts, 'attempts');
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInit);
  } else {
    startInit();
  }
})();
